import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColorVar, mode } from '@chakra-ui/theme-tools';
import { textStyles } from '../../common';

export const NumberInputStyles: ComponentStyleConfig = {
  baseStyle: (props) => {
    return {
      field: {
        '&&': {
          background: 'field',
        },
        borderRadius: '8px',
        outline: '2px solid transparent',
        '&&&': {
          boxShadow: 'none',
          borderColor: 'border.layer.0',
        },
        _hover: {
          background: `color-mix(in srgb, ${getColorVar(props.theme, 'field')} 90%, ${getColorVar(props.theme, 'gray.400')} 10%)`,
          '&&': {
            borderColor: 'border.1',
          },
        },
        _focusVisible: {
          outlineColor: 'state.selected',
        },
        _active: {
          background: 'field.active',
          '&&': {
            borderColor: 'state.selected',
          },
        },
        _invalid: {
          '&&&': {
            borderColor: 'state.error',
          },
        },
        _disabled: {
          opacity: 1,
          color: 'text.disabled',
          '&&&': {
            borderColor: 'border.1',
          },
        },
        _readOnly: {
          background: 'layer.0',
          cursor: props.cursor ?? 'not-allowed',
          '&&&': {
            borderColor: 'border.layer.0',
          },
        },
      },
      stepperGroup: {
        py: 0.5,
        w: 7,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
      },
      stepper: {
        color: mode('gray.900', 'gray.50')(props),
        bg: mode('blackAlpha.200', 'whiteAlpha.200')(props),
        borderStart: 'none',
        w: '22px',
        flex: '0 !important',
        borderRadius: '2px !important',
        _last: {
          borderTop: 'none',
        },
      },
    };
  },
  defaultProps: {
    errorBorderColor: 'red.300',
  },
  sizes: {
    xs: {
      stepper: {
        ...textStyles['body-sm'],
        h: 2,
      },
      field: {
        ...textStyles['body-sm'],
        px: 2, // 8px
        py: 1, // 4px
        height: '24px',
      },
      addon: {
        ...textStyles['body-sm'],
      },
    },
    sm: {
      stepper: {
        ...textStyles['body-sm'],
        h: 2.5,
      },
      field: {
        ...textStyles['body-sm'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '28px',
      },
      addon: {
        ...textStyles['body-sm'],
      },
    },
    md: {
      stepper: {
        ...textStyles['body-md'],
        h: 3,
      },
      field: {
        ...textStyles['body-md'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '32px',
      },
      addon: {
        ...textStyles['body-md'],
      },
    },
    lg: {
      stepper: {
        ...textStyles['body-md'],
        h: 4,
      },
      field: {
        ...textStyles['body-md'],
        px: 3, // 12px
        py: 2.5, // 10px
        height: '40px',
      },
      addon: {
        ...textStyles['body-md'],
      },
    },
  },
};
